import './form.scss';

class Form {
    constructor (element) {
        this.$form = element;
        this.$inputs = this.$form.querySelectorAll('input[type="text"]:not([name="contact[phone][number]"]), textarea');
        this.$inputPhone = this.$form.querySelector('input[type="text"][name="contact[phone][number]"]');
        this.$formContent = this.$form.parentNode;
        this.$submitButton = this.$form.querySelector('button[type="submit"]');

        this.initialize();
    }

    initialize () {
        if (this.$form) {
            this.checkActiveElement();
            this.validateInputs();
        }
    }

    checkInput ($input) {
        const initialInputValue = $input.value;
        const $formField = $input.closest('.form__field');
        $input.addEventListener('focus', () => {
            $formField.classList.add('is--filled');
        });

        $input.addEventListener('focusout', () => {
            const inputValue = $input.value;
            if (inputValue.length === 0) {
                $formField.classList.remove('is--filled');
            }
        });

        $input.addEventListener('change', () => {
            this.validateInputs();
        });

        if (initialInputValue.length > 0) {
            $formField.classList.add('is--filled');
        } else {
            $formField.classList.remove('is--filled');
        }
    }

    checkActiveElement () {
        if (this.$inputs.length > 0) {
            for (let i = 0; i < this.$inputs.length; i++) {
                this.checkInput(this.$inputs[i]);
            }
        }

        if (this.$inputPhone) {
            this.checkInput(this.$inputPhone);
        }
    }

    validateInputs () {
        let filledItems = 0;
        for (let i = 0; i < this.$inputs.length; i++) {
            const $input = this.$inputs[i];
            const inputValue = $input.value;
            if (inputValue.length > 0) {
                filledItems++;
            }
        }

        if (filledItems === this.$inputs.length) {
            this.$submitButton.removeAttribute('aria-disabled');
            this.$submitButton.disabled = false;
        } else {
            this.$submitButton.setAttribute('aria-disabled', 'true');
            this.$submitButton.disabled = true;
        }
    }
}

export { Form };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $forms = $context.querySelectorAll('.form');
        if ($forms.length > 0) {
            for (let i = 0; i < $forms.length; i++) {
                const formAPI = new Form($forms[i]);
                $forms[i].API = formAPI;
            }
        }
    }
});
